import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Form,
  Input,
  Icon,
  Row,
  Col,
  Button,
  Select,
  Checkbox,
  Modal
} from 'antd';
import styles from './AppStrategyItem.less';
const FormItem = Form.Item;
const Option = Select.Option;

let uuid = 0;
@inject('appStrategyStore', 'deviceGroupStore', 'appFileStore')
@observer
class AddStrategyComp extends Component {
  componentDidMount() {
    this.props.deviceGroupStore.loadDeviceGroup();
  }
  remove = k => {
    const { form } = this.props;
    const keys = form.getFieldValue('keys');
    form.setFieldsValue({
      keys: keys.filter(key => key !== k)
    });
  };
  add = () => {
    const { form } = this.props;
    const keys = form.getFieldValue('keys');
    const nextKeys = keys.concat(uuid);
    uuid++;
    form.setFieldsValue({
      keys: nextKeys
    });
  };
  handleSubmit = (e, checkVersion) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.appStrategyStore.hideAcrossVersionsModal();
        const form = new FormData();
        form.append('tag_id', values.tag_id);
        form.append('name', values.name);
        form.append('need_reboot', values.need_reboot || false);
        form.append('install_now', values['install_now'] || false);
        let appList = (values.appNames || []).map((item, index) => {
          return { id: item, current_version: values.appVersions[index] };
        });
        form.append('app_list', JSON.stringify(appList || []));
        this.props.appStrategyStore.AddAppStrategy(form).then(json => {
          if (json.code === 1406) {
            form.append('check_version', false);
            this.props.appStrategyStore.AcrossVersionsDate = form;
            this.props.appStrategyStore.showAcrossVersionsModal();
          } else {
            // this.props.appStrategyStore.currentPage = 1;
            // this.props.appStrategyStore.loadAppStrategyList(
            //   this.props.appStrategyStore.currentPage
            // );
            // this.props.appFileStore.loadAppList();
            // this.props.appStrategyStore.hideAddStrategyModal(this.props.form);
            // this.props.form.resetFields();
            // 如果这样操作只是数据改变表单里面的数据没有变化,导致页面展示问题
            window.location.reload();
          }
        });
      }
    });
  };
  changeHistoryStrategy = value => {
    const { strategyList, changeInitialData } = this.props.appStrategyStore;
    let data = [...strategyList].find(
      item => Number(item.id) === Number(value)
    );
    changeInitialData([...{ ...data }['app_list']], { ...data['install_now'] });
    this.props.form.setFieldsValue({
      tag_id: ({ ...data }.tag[0] || {}).id
    });
  };

  handleSelectChange = key => {
    let obj = {};
    obj[`appVersions[${key}]`] = '';
    this.props.form.setFieldsValue({
      ...obj
    });
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const {
      addStrategyModalStatus,
      strategyList,
      hideAddStrategyModal,
      AppListinitialValue,
      AppNameListinitialValue,
      AppStartListinitialValue,
      AppVersionListinitialValue
    } = this.props.appStrategyStore;
    const { deviceGroupArr } = this.props.deviceGroupStore;
    const { appListArr } = this.props;
    let apps = [...appListArr] || [];
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 }
      }
    };
    const formItemLayoutWithOutLabel = {
      wrapperCol: {
        xs: { span: 22, offset: 2 },
        sm: { span: 17, offset: 7 }
      }
    };
    getFieldDecorator('keys', {
      initialValue: [...AppListinitialValue]
    });
    const keys = getFieldValue('keys');

    const formItems = keys.map((k, index) => {
      let appId = getFieldValue(`appNames[${index}]`) || 0;
      let oneApp = apps.find(app => app['app_id'] == appId) || {};
      let versionOption = oneApp['file_list'] || [];
      return (
        <div key={index}>
          <Row>
            <Col span={10} offset={3}>
              <FormItem
                {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
                label={index === 0 ? '推送App' : ''}
                required={false}
                key={k}
              >
                {getFieldDecorator(`appNames[${index}]`, {
                  validateTrigger: ['onChange', 'onBlur'],
                  initialValue: [...AppNameListinitialValue][index],
                  rules: [
                    {
                      required: true,
                      message: '请选择推送的App'
                    }
                  ]
                })(
                  <Select
                    placeholder="请选择推送的App"
                    style={{ marginRight: 8, width: '95%' }}
                    onChange={() => this.handleSelectChange(index)}
                  >
                    {apps && apps.length
                      ? apps.map((app, index) => (
                          <Option key={index} value={app['app_id'] + ''}>
                            {app['app_name'] || '--'}
                          </Option>
                        ))
                      : ''}
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem wrapperCol={{ span: 24 }} required={false} key={index}>
                {getFieldDecorator(`appVersions[${index}]`, {
                  initialValue: [...AppVersionListinitialValue][index]
                })(
                  <Select placeholder="选择版本">
                    {[...versionOption] && [...versionOption].length
                      ? [...versionOption].map(a => (
                          <Option key={a.md5} value={a['app_version']}>
                            {a['app_version']}
                          </Option>
                        ))
                      : null}
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col span={7}>
              <FormItem required={false} key={k} wrapperCol={{ span: 24 }}>
                {getFieldDecorator(`appStart[${index}]`, {
                  valuePropName: 'checked',
                  initialValue: true
                })(
                  <Checkbox style={{ marginLeft: 8, width: '80%' }}>
                    设定为启动项
                  </Checkbox>
                )}
                {keys.length >= 1 ? (
                  <Icon
                    className="dynamic-delete-button"
                    type="minus-circle-o"
                    disabled={keys.length === 1}
                    onClick={() => this.remove(k)}
                  />
                ) : null}
              </FormItem>
            </Col>
          </Row>
        </div>
      );
    });
    return (
      <div>
        <Modal
          title="新建策略"
          visible={addStrategyModalStatus}
          onOk={this.handleSubmit}
          onCancel={() => hideAddStrategyModal(this.props.form)}
          closable={false}
          width={'50%'}
        >
          <Form onSubmit={this.handleSubmit}>
            <FormItem
              label="策略名称"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 12 }}
            >
              {getFieldDecorator('name', {
                initialValue: '',
                rules: [
                  { required: true, message: '请填写策略名称' },
                  { max: 50, message: '名称不能超过50个字符' }
                ]
              })(<Input name="name" />)}
            </FormItem>
            <FormItem
              label="从已有策略新建:"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 12 }}
            >
              {getFieldDecorator('historyStrategy')(
                <Select
                  placeholder="从已有策略新建"
                  onChange={this.changeHistoryStrategy}
                >
                  {[...strategyList].map(item => (
                    <Option key={item.id} value={item.id + ''}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
            <FormItem
              label="设备分组:"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 12 }}
            >
              {getFieldDecorator('tag_id', {
                rules: [{ required: true, message: '请填写设备分组' }]
              })(
                <Select placeholder="请填写设备分组">
                  {[...deviceGroupArr].map(item => (
                    <Option key={item.tag_id} value={item.tag_id + ''}>
                      {item.tag_name}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
            {formItems}
            <FormItem
              label={keys && keys.length ? '' : '推送App'}
              labelCol={{ span: 8 }}
              wrapperCol={{
                span: 12,
                offset: keys && keys.length ? 8 : 0
              }}
            >
              <Button
                type="dashed"
                onClick={this.add}
                disabled={keys.length > 0}
              >
                <Icon type="plus" /> 添加App
              </Button>
            </FormItem>
            <FormItem wrapperCol={{ span: 12, offset: 8 }}>
              {getFieldDecorator('need_reboot', {
                initialValue: false,
                valuePropName: 'checked'
              })(
                <Checkbox className={styles.updataCheckBox}>
                  是否更新完重启设备
                </Checkbox>
              )}
            </FormItem>
            <FormItem wrapperCol={{ span: 12, offset: 8 }}>
              {getFieldDecorator('install_now', {
                initialValue: false,
                valuePropName: 'checked'
              })(
                <Checkbox className={styles.updataCheckBox}>
                  是否立即更新App
                </Checkbox>
              )}
            </FormItem>
          </Form>
        </Modal>
      </div>
    );
  }
}

const AddStrategy = Form.create()(AddStrategyComp);
export default AddStrategy;



// WEBPACK FOOTER //
// ./src/components/AppStrategy/AddStrategy.js